import { Button, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import React, { useEffect } from "react";
import eKyc from "../../../../assets/images/kyc/Logo-eKYC.png";
import iconSvg from "../../../../assets/images/icon/check.svg";
import iconNext from "../../../../assets/images/icon/next-arrow.svg";
import "../../../../i18n/i18n";
import { i18n } from '../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../i18n/i18n.constants";

const DaolInvReviewSuitAndKycPage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation(namespaces.pages.daolinvReviewSuitAndKyc);
  console.log(t("title"))
  const param_customer = localStorage.getItem("param_customer");

  useEffect(() => { }, [window.document.title = "DAOL - Review Information"]);
  const onClickNext = () => {
    history.push({
      pathname: "/contents/daolInv/reviewSuitAndKyc/loginDate",
      state: {
        customerId: param_customer
      },
    });
  }

  return (
    <>
      <Row className="container-main daol-inv-ekyc">
        {/* {console.log('useTranslation(namespaces.pages.daolinvReviewSuitAndKyc)', i18n.language)}
        {console.log('param_customerparam_customerparam_customer', param_customer)} */}
        <div className="content-right col-sm-9 text-center">
          <span className="text-large-header"><b>{t("title")}</b></span>
          <p className="text-large-header"><b>{t("title_en")}</b></p>

          <div className="company-name">
            <span>{t("company")}</span>
            <p>{t("company_en")}</p>
          </div>
          
          <span className="sub-text-header mt-40"><b>{t("descrip_p1")}</b></span>
          <div className="text-left descrip-content">
            <p className="mb-0"><img src={iconSvg} alt="icon" />{t("descrip_p2")}</p>
            <p className="mb-0"><img src={iconSvg} alt="icon" />{t("descrip_p3")}</p>
            <p className="mb-0"><img src={iconSvg} alt="icon" />{t("descrip_p6")}</p>
            <p className="remark-ekyc-sec" >{t("descrip_p6_remark")}</p>
          </div>
          <span className="sub-text-header mt-20"><b>{t("descrip_p4")}</b></span>
          <div className="text-left descrip-content">
            <span><img src={iconSvg} alt="icon" />{t("descrip_p5")}</span>
          </div>

          <p className="remark-ekyc mt-20">{t("descrip_remark")}</p>
          <span className="remark-ekyc">{t("descrip_remark_en")}</span>

          <div className="container-button btn-kyc">
            {param_customer === 'undefined' ? (
              <Button
                type="primary"
                className="btn-next mt-20"
                onClick={() => history.push(`/contents/daolInv/reviewSuitAndKyc/loginekyc`)}
              >
                {t("btn_next")}
                <img src={iconNext} alt="icon-next" />
              </Button>) :
              (<Button
                type="primary"
                className="btn-next mt-20"
                onClick={onClickNext}
              >
                {t("btn_next")}
                <img src={iconNext} alt="icon-next" />
              </Button>)}
          </div>
        </div>
      </Row>

    </>
  );
};
export default DaolInvReviewSuitAndKycPage;
